/**
 * OnboardingStep2 — Storia clinica (PR4 Fase 5).
 *
 * Tutti i campi sono opzionali (textarea), max 2000 char ciascuno.
 * Il paziente puo' saltarli, lo studio li integrera' nelle visite successive.
 */

import type { FieldErrors, UseFormRegister } from 'react-hook-form';
import type { OnboardingFormValues } from './onboarding-form-types';
import { FieldRow, TextArea } from '@shared/components/ui/FormField';

interface Step2Props {
  register: UseFormRegister<OnboardingFormValues>;
  errors: FieldErrors<OnboardingFormValues>;
}

export function OnboardingStep2({ register, errors }: Step2Props) {
  const e = errors.step2;
  return (
    <fieldset className="flex flex-col gap-4">
      <legend className="sr-only">Storia clinica</legend>
      <p className="text-sm text-text-secondary">
        Questi campi sono facoltativi. Compila quelli che ti riguardano: ci aiutano a
        preparare meglio la prima visita.
      </p>

      <FieldRow
        id="step2-storiaFamiliare"
        label="Storia familiare"
        hint="Patologie ricorrenti nei parenti stretti (diabete, ipertensione, ecc.)"
        error={e?.storiaFamiliare?.message}
      >
        {(a) => <TextArea {...a} {...register('step2.storiaFamiliare')} rows={3} />}
      </FieldRow>

      <FieldRow
        id="step2-patologie"
        label="Patologie attuali o pregresse"
        error={e?.patologie?.message}
      >
        {(a) => <TextArea {...a} {...register('step2.patologie')} rows={3} />}
      </FieldRow>

      <FieldRow
        id="step2-interventi"
        label="Interventi chirurgici"
        error={e?.interventi?.message}
      >
        {(a) => <TextArea {...a} {...register('step2.interventi')} rows={2} />}
      </FieldRow>

      <FieldRow
        id="step2-farmaci"
        label="Farmaci e integratori in corso"
        error={e?.farmaci?.message}
      >
        {(a) => <TextArea {...a} {...register('step2.farmaci')} rows={3} />}
      </FieldRow>

      <FieldRow
        id="step2-allergieIntolleranze"
        label="Allergie e intolleranze (incluso nichel)"
        error={e?.allergieIntolleranze?.message}
      >
        {(a) => <TextArea {...a} {...register('step2.allergieIntolleranze')} rows={3} />}
      </FieldRow>
    </fieldset>
  );
}
